module.exports = __webpack_public_path__ + "img/2.316ef3a9.jpg";